import {defaultPageSize} from './cursor-pagination-const';
import {cursorPaginationStateSchema, CursorPaginationStateType} from './cursor-pagination-type';

const cursorPaginationCacheDurationMs = 15 * 60 * 1000;

function getCursorPaginationFullStorageKey(storageKey: string): string {
    return `pagination_${storageKey}`;
}

export function getPaginationInitialState(options: {
    useStorage: boolean;
    storageKey: string;
    defaultPageSize?: number;
}): Omit<CursorPaginationStateType, 'timestamp'> {
    const {useStorage, defaultPageSize: optionsPageSize, storageKey} = options;

    if (useStorage) {
        const storedPaginationState = sessionStorage.getItem(getCursorPaginationFullStorageKey(storageKey));
        const parseResult = cursorPaginationStateSchema.safeParse(JSON.parse(storedPaginationState || '{}'));

        if (parseResult.success && Date.now() - parseResult.data.timestamp < cursorPaginationCacheDurationMs) {
            return parseResult.data;
        }
    }

    return {
        pageSize: optionsPageSize || defaultPageSize,
        cursor: '',
        storageKey: '',
    };
}

export function saveNewCursorPaginationState(data: Omit<CursorPaginationStateType, 'timestamp'>): void {
    sessionStorage.setItem(
        getCursorPaginationFullStorageKey(data.storageKey),
        JSON.stringify({
            ...data,
            timestamp: Date.now(),
        })
    );
}
